var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "#FFD670",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.04485 0.809196C2.77559 0.809196 0.937988 2.62182 0.937988 4.85522C0.937988 7.08863 2.77559 8.90125 5.04485 8.90125C7.31821 8.90125 9.15993 7.08863 9.15993 4.85522C9.15993 2.62182 7.31821 0.809196 5.04485 0.809196ZM5.04896 8.09204C3.23191 8.09204 1.76018 6.64356 1.76018 4.85522C1.76018 3.06688 3.23191 1.6184 5.04896 1.6184C6.86601 1.6184 8.33773 3.06688 8.33773 4.85522C8.33773 6.64356 6.86601 8.09204 5.04896 8.09204Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2544 2.83221H4.63776V5.25982L6.79601 6.53432L7.10434 6.03666L5.2544 4.95637V2.83221Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock2);
export default __webpack_public_path__ + "static/media/clock2.aa4e7f331ba89217e1716691241adbbf.svg";
export { ForwardRef as ReactComponent };